import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import RocketIcon from '@interxfi/design-system/icons/react/icon-rocket';
import { O5DeploymentTriggerDrawer } from '../../../../../../../features/o5/deployment/o5-deployment-trigger-drawer';
import { O5DeploymentsTable } from '../../../../../../../features/o5/deployment/o5-deployments-table';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/deployment/_deployment/')({
  head: () => getPageHead('Deployments'),
  component: O5DeploymentList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        <O5DeploymentTriggerDrawer trigger={<Button affixIcon={<RocketIcon aria-hidden />} aria-label="Trigger Deployment" size="small" />} />
        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function O5DeploymentList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <O5DeploymentsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
